module.exports = __webpack_public_path__ + "img/bicycle.98c22b22.jpg";